import { Autocomplete, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { renderFullName } from '../helpers/utils';
import { useGetTopListQuery } from 'src/app/services/staffApi';

const TopManagerSelector = ({ value, onChange, label = 'Employee' }) => {
  const { t } = useTranslation('translations');
  const { data: topManagerList } = useGetTopListQuery();
  const [currentStaff, setCurrentStaff] = useState(value ?? null);

  useEffect(() => onChange(currentStaff), [currentStaff, onChange]);

  if (!topManagerList?.length) return null;

  return (
    <Autocomplete
      value={currentStaff}
      getOptionLabel={(option) => renderFullName(option) ?? ''}
      isOptionEqualToValue={(option, _value) => option.id === _value.id}
      options={topManagerList}
      renderOption={(_props, option) => (
        <li {..._props} key={option.id}>
          {option.name}
        </li>
      )}
      fullWidth
      noOptionsText={t('NoOptions')}
      onChange={(e, _value) => setCurrentStaff(_value)}
      renderInput={(params) => <TextField {...params} size="small" label={t(label)} />}
    />
  );
};

export default TopManagerSelector;
